export default __webpack_public_path__ + "assets/images/5daaa60ece84b2e68d03f7a889276707.png";